import { getCookie } from '../aem.js';

function isObject(item) {
  return (item && typeof item === 'object' && !Array.isArray(item) && !(item instanceof Date));
}

function deepMerge(target, ...sources) {
  if (!sources.length) return target;

  sources.forEach((source) => {
    if (isObject(target) && isObject(source)) {
      const keys = Object.keys(source);

      for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        if (isObject(source[key])) {
          if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
            continue;
          }

          if (!target[key] || !isObject(target[key])) {
            target[key] = {};
          }

          deepMerge(target[key], source[key]);
        } else {
          target[key] = source[key];
        }
      }
    }
  });

  return target;
}

function getSubdomain(hostname) {
  const parts = hostname.split('.');
  if (parts.length > 2) {
    const subdomain = parts.slice(0, -2).join('.');
    const subdomainMap = {
      www: 'commercial',
    };
    return subdomainMap[subdomain] || subdomain;
  }
  return undefined;
}

function getTrackingCode(urlParams) {
  const campID = urlParams.get('campID');

  if (campID) {
    return campID;
  }

  const utmParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_id', 'utm_term', 'utm_content'];
  const utmValues = utmParams.map((param) => urlParams.get(param) || 'undefined');

  if (utmValues.some((value) => value !== 'undefined')) {
    return `UTM|${utmValues.join('|')}`;
  }

  return undefined;
}

function getPreviousURL() {
  const docReferrer = document.referrer;

  if (docReferrer) {
    const referrerHost = new URL(docReferrer).hostname;
    if (referrerHost === window.location.hostname) {
      return docReferrer;
    }
  }
  return undefined;
}

function getPublishDate() {
  const dateFromMeta = document.head.querySelector('meta[name="publication-date"]');
  if (dateFromMeta) {
    const date = new Date(dateFromMeta.content);
    return `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
  }
  return undefined;
}

function populatePageViewXDM(dataObj) {
  const urlParams = new URLSearchParams(window.location.search);

  dataObj.eventType = 'pageView';
  dataObj.web.webPageDetails = {
    ...dataObj.web.webPageDetails,
    directory: window.location.pathname.split('/')[1] || undefined,
    subdomain: getSubdomain(window.location.hostname),
    server: window.location.hostname,
    previousURL: getPreviousURL(),
    title: document.title.toLowerCase(),
    isErrorPage: window.isErrorPage || false,
    pageError: window.errorCode || 'no error found',
    language: document.documentElement.lang,
    country: sessionStorage.getItem('selectedCountry')?.toLowerCase() || undefined,
    author: document.head.querySelector('meta[name="author"]')?.content?.toLowerCase() || undefined,
    publishDate: getPublishDate(),
    trackingCode: getTrackingCode(urlParams),
    utmSource: urlParams.get('utm_source') || undefined,
    utmMedium: urlParams.get('utm_medium') || undefined,
    utmCampaign: urlParams.get('utm_campaign') || undefined,
    utmID: urlParams.get('utm_id') || undefined,
    utmTerm: urlParams.get('utm_term') || undefined,
    utmContent: urlParams.get('utm_content') || undefined,
    pageViews: {
      value: 1,
    },
  };

  dataObj._celonis = {
    user: {
      userID: undefined,
      externalID: {
        adobeID: (typeof getCookie === 'function' ? getCookie('AMCV') : undefined) || 'no adobe id cookie found',
        googleID: `${(typeof getCookie === 'function' ? getCookie('_ga') : undefined) || 'no _ga cookie found'} | ${(typeof getCookie === 'function' ? getCookie('NID') : undefined) || 'no NID cookie found'}`,
      },
    },
    environment: {
      browserDetails: {
        userAgent: navigator.userAgent,
      },
    },
    device: {
      type: undefined,
    },
  };
}

function addGenericXDM(dataObj) {
  dataObj.web.webPageDetails = {
    ...dataObj.web.webPageDetails,
    path: window.location.pathname,
    fullPath: window.location.origin + window.location.pathname,
    URLQuery: window.location.search || undefined,
  };
}

function addEventDataToXDM(dataObj, eventType) {
  const dataLayer = window.adobeDataLayer;
  if (dataLayer?.length) {
    const dataLayerLast = dataLayer.at(-1);
    if (dataLayerLast.event === eventType) {
      const newObject = deepMerge({}, dataObj, dataLayerLast);
      delete newObject.event;
      return newObject;
    }
  }
  return dataObj;
}

function checkEventPayload(payload) {
  const { xdm } = payload;
  const { eventType } = xdm;
  addGenericXDM(xdm);
  payload.xdm = addEventDataToXDM(xdm, eventType);
  if (eventType === 'web.webpagedetails.pageViews') {
    populatePageViewXDM(xdm);
  }
}

export {
  checkEventPayload,
};
